import Toastr from "../../../../../itrust_common/components/Toastr";


const DEFAULT_STATE = {
  loading: false,
  saving: false,
  services: [],
  procedures: [],
  syncItems: []
};

let changes = null;

export default function visionInsuranceMappingReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {

    case 'VISION_INSURANCE_PROCEDURE_MAPPINGS_LOAD_PENDING':
    case 'VISION_INSURANCE_PROCEDURE_MAPPINGS_PREFILLED_LOAD_PENDING':
    case 'VISION_INSURANCE_PROCEDURE_MAPPING_CREATE_PENDING':
    case 'SYNC_MEMBER_BENEFIT_LOAD_PENDING':
      return {
        ...state,
        loading: true,
        saving: true
      };

    case 'VISION_INSURANCE_PROCEDURE_MAPPINGS_LOAD_REJECTED':
    case 'VISION_INSURANCE_PROCEDURE_MAPPINGS_PREFILLED_LOAD_REJECTED':
    case 'VISION_INSURANCE_PROCEDURE_MAPPING_CREATE_REJECTED':
    case 'SYNC_MEMBER_BENEFIT_LOAD_REJECTED':
      if (response?.data) {
        Toastr.handleShow(
          response.data.success,
          response.data.error,
          response.data.status_code
        );
      }

      return {
        ...state,
        loading: false,
        saving: false
      };

    case 'VISION_INSURANCE_PROCEDURE_MAPPINGS_LOAD_FULFILLED':
      changes = {
        services: action.payload.data || [],
        procedures: action.payload.data || [],
        loading: false,
        saving: false
      };

      return { ...state, ...changes };

    case 'VISION_INSURANCE_PROCEDURE_MAPPINGS_PREFILLED_LOAD_FULFILLED':
      const rawMappings = action.payload.data?.benefit_mappers || action.payload.data?.mappings || [];
      const mappedMappings = rawMappings.map(m => ({
        ...m,
        selected_procedure_ids: m.mapper_ids
      }));
      changes = {
        services: { benefit_mappers: mappedMappings, services: mappedMappings },
        procedures: mappedMappings,
        loading: false,
        saving: false
      };

      return { ...state, ...changes };

    case 'VISION_INSURANCE_PROCEDURE_MAPPING_CREATE_FULFILLED':
      Toastr.handleShow(
        true, response.message, 200
      );


      changes = {
        saving: false,
        loading: false
      }
      return { ...state, ...changes };

    case 'SYNC_MEMBER_BENEFIT_LOAD_FULFILLED':
      changes = {
        syncItems: response?.items || response?.sync_items || [],
        loading: false,
        saving: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}
